import { z } from 'zod'

/**
 * A subscription as the legacy admin portal knows it. Read from the warehouse's `subscriptions`
 * mirror of Firestore and never copied into the app database beyond the id a migrated report
 * carries in its settings (`legacySubscriptionId`) — the key its delivery ledger rows, its
 * previously-sent set and the preview test-account fence are all read by. An unknown id reads as
 * an empty ledger rather than an error, which is why the picker shows names and statuses.
 */
export const legacySubscriptionSchema = z.object({
  id: z.string(),
  name: z.string(),
  /** `ENABLED` / `DISABLED` in the legacy data. */
  status: z.string().nullable(),
  /** The legacy template key, e.g. `EMERALD`, `BCG_TARIFFS`, or empty for the default. */
  template: z.string().nullable(),
  /** The legacy delivery subject, which usually names the report better than `name` does. */
  subject: z.string().nullable(),
})
export type LegacySubscription = z.infer<typeof legacySubscriptionSchema>

export const searchLegacySubscriptionsQueryStringSchema = z.object({
  /** A name fragment or an exact id. Empty lists the enabled subscriptions first. */
  q: z.string().trim().max(200).default(''),
})

export const listLegacySubscriptionsResponseSchema = z.object({
  subscriptions: z.array(legacySubscriptionSchema),
})
export type ListLegacySubscriptionsResponse = z.infer<typeof listLegacySubscriptionsResponseSchema>
